import React from "react";

// ─── Badge configs ─────────────────────────────────────────────────────────────
const BADGE_CONFIGS = {
  sentiment: {
    positive: { bg: "rgba(16,185,129,0.1)",  color: "#059669", border: "rgba(16,185,129,0.2)",  label: "↑ Positive" },
    negative: { bg: "rgba(239,68,68,0.1)",   color: "#DC2626", border: "rgba(239,68,68,0.2)",   label: "↓ Negative" },
    neutral:  { bg: "rgba(100,116,139,0.1)", color: "#64748B", border: "rgba(100,116,139,0.2)", label: "→ Neutral"  },
  },
  legality: {
    lawful:   { bg: "rgba(16,185,129,0.1)", color: "#059669", border: "rgba(16,185,129,0.2)", label: "✓ Lawful"   },
    unlawful: { bg: "rgba(239,68,68,0.1)",  color: "#DC2626", border: "rgba(239,68,68,0.2)",  label: "✗ Unlawful" },
  },
  severity: {
    low:      { bg: "rgba(16,185,129,0.1)",  color: "#059669", border: "rgba(16,185,129,0.2)",  label: "Low"      },
    moderate: { bg: "rgba(245,158,11,0.1)",  color: "#D97706", border: "rgba(245,158,11,0.2)",  label: "Moderate" },
    high:     { bg: "rgba(239,68,68,0.1)",   color: "#DC2626", border: "rgba(239,68,68,0.2)",   label: "High"     },
    critical: { bg: "rgba(239,68,68,0.15)",  color: "#B91C1C", border: "rgba(239,68,68,0.3)",   label: "Critical" },
  },
};

export function Badge({ value, type }) {
  if (!value) return null;
  const map = BADGE_CONFIGS[type] ?? {};
  const cfg = map[value.toLowerCase()];
  if (!cfg) return null;

  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 20,
      letterSpacing: "0.2px", background: cfg.bg, color: cfg.color,
      border: `1px solid ${cfg.border}`,
      fontFamily: "'Host Grotesk', sans-serif", whiteSpace: "nowrap",
    }}>
      {cfg.label}
    </span>
  );
}

export function Chip({ children, accent, mono }) {
  return (
    <span style={{
      fontSize: 10.5,
      fontFamily: mono ? "monospace" : "'Host Grotesk', sans-serif",
      fontWeight: 600,
      color:      accent ? "#6D28D9" : "#64748B",
      background: accent ? "rgba(109,40,217,0.06)" : "#FFFFFF",
      border:     `1px solid ${accent ? "rgba(109,40,217,0.18)" : "#E9ECF0"}`,
      borderRadius: 6,
      padding: "2px 7px",
    }}>
      {children}
    </span>
  );
}

export function Stat({ icon, val }) {
  return (
    <span style={{
      display: "flex", alignItems: "center", gap: 3,
      fontSize: 11, fontWeight: 600, color: "#6B7280",
      fontFamily: "'Host Grotesk', sans-serif",
    }}>
      <span style={{ fontSize: 11 }}>{icon}</span>
      {val}
    </span>
  );
}

/** Spinning loader ring */
export function Spinner({ size = 20, color = "#F59E0B" }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      border: "2px solid #F0F2F5", borderTopColor: color,
      animation: "spin 0.7s linear infinite",
      flexShrink: 0,
    }} />
  );
}
